
import { indexProjectBatchesOperation, indexBatchFilesOperation } from "@api/services/backstage"

const listProjectFiles = async (request, projectId) => {
  const files = []

  const { data: projectBatches } = await request(indexProjectBatchesOperation, { projectId })

  const promises = projectBatches
    .map(({ id: batchId }) =>
      request(indexBatchFilesOperation, { batchId })
        .then(({ data: batchFiles }) => files.push(...batchFiles))
    )

  await Promise.all(promises)
  return [ projectBatches, files ]
}

export default listProjectFiles
